// ** React Imports
import { lazy } from 'react';

const MedicinesRoutes = [
  {
    path: 'medicines',
    component: lazy(() => import('pages/medicines')),
  },
];

export default MedicinesRoutes;
